import { memo } from 'react';
import Axios from '../../../services/axios';
import MarkDownView from '@/components/MarkDownView';
import { useCourseData } from '@/pages/Course';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import { Loading } from '../Loading'
import YoutubeVids from '../YoutubeVids';
import { useQuery } from '@tanstack/react-query';

function Topic({ topic }) {
  const { course } = useCourseData();

  const fetchTopic = async () => {
    const courseData = { topic, ...course };
    const { data } = await Axios.post(`/course/topic/${course._id}`, courseData);
    return data.data;
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: ['topic', topic],
    queryFn: fetchTopic,
    staleTime: Infinity,
  });

  if (isLoading) {
    return (
      <div className="p-8">
        <Loading />
      </div>
    );
  }

  if (isError) {
    return <div className="p-8 text-center text-red-500">Failed to load topic. Please try again.</div>;
  }

  return (
    <ScrollArea className="h-full">
      <div className="container mx-auto p-2 md:p-6 lg:p-8 bg-muted/20">
        <div className="flex flex-col lg:flex-row lg:gap-8">
          <main className="w-full lg:w-2/3 min-w-0">
            <article>
              <MarkDownView>{data?.markdownText || 'No content available for this topic.'}</MarkDownView>
            </article>
          </main>
          <div className="my-8 lg:hidden">
            <Separator />
          </div>

          <aside className="w-full lg:w-1/3 lg:sticky lg:top-8 self-start">
            <div className="rounded-xl border bg-zinc-50 p-4 dark:bg-zinc-900 dark:border-zinc-800">
              <h2 className="mb-4 text-lg font-semibold tracking-tight text-zinc-900 dark:text-zinc-50">
                ✨ Suggested Videos
              </h2>
              <YoutubeVids videos={data?.suggestedVideos || []} />
            </div>
          </aside>
        </div>
      </div>
    </ScrollArea>
  );
}

export default memo(Topic);
